import { Reveal } from "./Motion";
import { Heart, Users2, Shield } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function About() {
  const { t } = useLang();
  const VALUES = [
    { icon: Heart, color: "hsl(var(--coral))", bg: "#FFE5DE", title: t("about.v1.title"), text: t("about.v1.text") },
    { icon: Users2, color: "hsl(var(--primary))", bg: "hsl(var(--sky))", title: t("about.v2.title"), text: t("about.v2.text") },
    { icon: Shield, color: "hsl(var(--plum))", bg: "#EFE7F3", title: t("about.v3.title"), text: t("about.v3.text") },
  ];

  return (
    <section id="a-propos" className="py-16 md:py-24 bg-muted/50" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-12 gap-8 md:gap-10 items-start">
          <div className="md:col-span-5">
            <Reveal>
              <div className="chip">{t("about.chip")}</div>
              <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-[1.05]">
                {t("about.title_1")} <span className="text-primary">{t("about.title_humaine")}</span>
              </h2>
              <p className="mt-5 text-lg text-foreground/80 leading-relaxed">{t("about.p1")}</p>
              <p className="mt-4 text-base text-foreground/70 leading-relaxed">{t("about.p2")}</p>
            </Reveal>
          </div>

          <div className="md:col-span-7 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5" data-testid="about-values">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.06}>
                <div className="bg-white rounded-3xl p-6 border border-border h-full">
                  <div className="w-12 h-12 rounded-2xl grid place-items-center" style={{ backgroundColor: v.bg, color: v.color }}>
                    <v.icon className="w-6 h-6" strokeWidth={2.2} />
                  </div>
                  <h3 className="mt-4 font-heading text-lg leading-tight">{v.title}</h3>
                  <p className="mt-2 text-sm text-foreground/75 leading-relaxed">{v.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
